import React from "react";
import { Link } from "react-router-dom";
import * as PR from "../../prime-react/index";
import { notFound } from "../../assets/images/index";

// CSS
import "./PageNotFound.scss";
import { useSelector } from "react-redux";

const PageNotFound = () => {
  const isAuthenticated = useSelector(state => state.auth.isLoggedIn);
  return (
    <>
      <section className="notfound-section">
        <div className="grid grid-nogutter align-items-center custom-height">
          <div className="col-12 text-center">
            <PR.Image src={notFound} alt="not found" className="notfound-img" />
            <h1 className="text-4xl font-semibold"> Page Not found </h1>
            <Link to={isAuthenticated ? "/home" : '/login'} className="backtohome-btn"><i className="pi pi-chevron-left"></i> Back to {isAuthenticated ? 'Home' : 'Login'}</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageNotFound;